// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-sZ6","toggle":"styles_toggle__16viB","preview":"styles_preview__3r-eK"};